import KeyCode from "@/assets/constants/key-code";

export const keyCodeLabel: Record<KeyCode, string> = {
  [KeyCode.BACKSPACE]: "Backspace",
  [KeyCode.TAB]: "Tab",
  [KeyCode.ENTER]: "Enter",
  [KeyCode.SHIFT]: "Shift",
  [KeyCode.CTRL]: "Ctrl",
  [KeyCode.ALT]: "Alt",
  [KeyCode.PAUSE_BREAK]: "Pause",
  [KeyCode.CAPS_LOCK]: "CapsLock",
  [KeyCode.ESCAPE]: "Esc",
  [KeyCode.SPACE]: "Space",
  [KeyCode.PAGE_UP]: "PageUp",
  [KeyCode.PAGE_DOWN]: "PageDown",
  [KeyCode.END]: "End",
  [KeyCode.HOME]: "Home",
  [KeyCode.LEFT_ARROW]: "◄",
  [KeyCode.UP_ARROW]: "▲",
  [KeyCode.RIGHT_ARROW]: "►",
  [KeyCode.DOWN_ARROW]: "▼",
  [KeyCode.PRINT_SCREEN]: "PrintScreen",
  [KeyCode.INSERT]: "Insert",
  [KeyCode.DELETE]: "Delete",
  [KeyCode.KEY_0]: "0",
  [KeyCode.KEY_1]: "1",
  [KeyCode.KEY_2]: "2",
  [KeyCode.KEY_3]: "3",
  [KeyCode.KEY_4]: "4",
  [KeyCode.KEY_5]: "5",
  [KeyCode.KEY_6]: "6",
  [KeyCode.KEY_7]: "7",
  [KeyCode.KEY_8]: "8",
  [KeyCode.KEY_9]: "9",
  [KeyCode.A]: "A",
  [KeyCode.B]: "B",
  [KeyCode.C]: "C",
  [KeyCode.D]: "D",
  [KeyCode.E]: "E",
  [KeyCode.F]: "F",
  [KeyCode.G]: "G",
  [KeyCode.H]: "H",
  [KeyCode.I]: "I",
  [KeyCode.J]: "J",
  [KeyCode.K]: "K",
  [KeyCode.L]: "L",
  [KeyCode.M]: "M",
  [KeyCode.N]: "N",
  [KeyCode.O]: "O",
  [KeyCode.P]: "P",
  [KeyCode.Q]: "Q",
  [KeyCode.R]: "R",
  [KeyCode.S]: "S",
  [KeyCode.T]: "T",
  [KeyCode.U]: "U",
  [KeyCode.V]: "V",
  [KeyCode.W]: "W",
  [KeyCode.X]: "X",
  [KeyCode.Y]: "Y",
  [KeyCode.Z]: "Z",
  [KeyCode.LEFT_META]: "Meta",
  [KeyCode.RIGHT_META]: "Meta",
  [KeyCode.SELECT]: "Select",
  [KeyCode.NUMPAD_0]: "Num 0",
  [KeyCode.NUMPAD_1]: "Num 1",
  [KeyCode.NUMPAD_2]: "Num 2",
  [KeyCode.NUMPAD_3]: "Num 3",
  [KeyCode.NUMPAD_4]: "Num 4",
  [KeyCode.NUMPAD_5]: "Num 5",
  [KeyCode.NUMPAD_6]: "Num 6",
  [KeyCode.NUMPAD_7]: "Num 7",
  [KeyCode.NUMPAD_8]: "Num 8",
  [KeyCode.NUMPAD_9]: "Num 9",
  [KeyCode.MULTIPLY]: "*",
  [KeyCode.ADD]: "+",
  [KeyCode.SUBTRACT]: "-",
  [KeyCode.DECIMAL_POINT]: ".",
  [KeyCode.DIVIDE]: "/",
  [KeyCode.F1]: "F1",
  [KeyCode.F2]: "F2",
  [KeyCode.F3]: "F3",
  [KeyCode.F4]: "F4",
  [KeyCode.F5]: "F5",
  [KeyCode.F6]: "F6",
  [KeyCode.F7]: "F7",
  [KeyCode.F8]: "F8",
  [KeyCode.F9]: "F9",
  [KeyCode.F10]: "F10",
  [KeyCode.F11]: "F11",
  [KeyCode.F12]: "F12",
  [KeyCode.NUM_LOCK]: "NumLock",
  [KeyCode.SCROLL_LOCK]: "ScrollLock",
  [KeyCode.SEMICOLON]: ";",
  [KeyCode.EQUAL_SIGN]: "=",
  [KeyCode.COMMA]: ",",
  [KeyCode.DASH]: "-",
  [KeyCode.PERIOD]: ".",
  [KeyCode.FORWARD_SLASH]: "/",
  [KeyCode.GRAVE_ACCENT]: "`",
  [KeyCode.OPEN_BRACKET]: "[",
  [KeyCode.BACKSLASH]: "\\",
  [KeyCode.CLOSE_BRACKET]: "]",
  [KeyCode.SINGLE_QUOTE]: "'",
};
